import videojs from 'video.js'

export default class VideoLink {
  static init (el) {
    return new VideoLink(el)
  }

  constructor (el) {
    this.node = el
    this.video = el.querySelector('video')
    this.isPlaing = false
    this.playVideo = this.playVideo.bind(this)
    this.pauseVideo = this.pauseVideo.bind(this)
    this.addEventListeners = this.addEventListeners.bind(this)
    // this.browser = navigator.userAgent
    // this.checkBrowser()
    if (!window.navigator.userAgent.match(/MSIE/)) { this.video.setAttribute('preload', 'auto') }

    this.initVideoJS()
  }

  static isParent (refNode, otherNode) {
    if (!otherNode) { return }

    let parent = otherNode.parentNode

    do {
      if (refNode === parent) {
        return true
      } else {
        parent = parent.parentNode
      }
    } while (parent)

    return false
  }

  initVideoJS () {
    videojs.options.flash.swf = 'video-js.swf'
    this.player = videojs(this.video, {}, () => {
      this.poster = this.node.querySelector('.vjs-poster').style.transition = 'easy-in-out all 2s'
      this.addEventListeners()
    })
  }

  playVideo () {
    if (!this.isPlaing) {
      const playPromise = this.player.play()

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          this.isPlaing = true
        })
          .catch(error => {
            console.error(error.message)
          })
      }
    }
  }

  pauseVideo () {
    const target = window.event.toElement || window.event.relatedTarget || window.event.target

    if (!this.constructor.isParent(this.node, target)) {
      this.player.pause()
      this.isPlaing = false
    }
  }

  addEventListeners () {
    this.node.addEventListener('mouseenter', this.playVideo)
    this.node.addEventListener('mouseout', this.pauseVideo)
  }
}
